import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { omit } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers';

const styles = (theme) => ({
  label: {
    fontWeight: '500',
    color: theme.palette.primary.main,
  },
});

class FormDatePicker extends PureComponent {
  handleChange = (value) => {
    const { input, onChangeCustom } = this.props;

    input.onChange(value);

    if (onChangeCustom) onChangeCustom(value);
  };

  render() {
    const {
      classes,
      customFormat,
      input: { name, value },
      ...custom
    } = this.props;

    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <DatePicker
          animateYearScrolling={false}
          format={customFormat || 'MM/DD/YYYY'}
          name={name}
          onChange={this.handleChange}
          value={value || null}
          {...omit(custom, 'onChangeCustom')}
          // https://github.com/react-dnd/react-dnd/issues/701
          onDrop={(e) => e.preventDefault()}
        />
      </MuiPickersUtilsProvider>
    );
  }
}

FormDatePicker.propTypes = {
  classes: PropTypes.object.isRequired,
  customFormat: PropTypes.string,
  input: PropTypes.object.isRequired,
  label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  onChangeCustom: PropTypes.func,
};

FormDatePicker.defaultProps = {
  label: '',
  onChangeCustom: undefined,
};

export default withStyles(styles)(FormDatePicker);
